module.exports = __webpack_public_path__ + "img/infibo-system-scheme-ru.cea79c48.png";